module.exports = global["$"] = require("-!/var/www/iworis-cms/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 375
// module chunks = 3